import script from "./UploadServiceProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadServiceProduct.vue?vue&type=script&setup=true&lang=js"

import "./UploadServiceProduct.vue?vue&type=style&index=0&id=acfdc6c8&lang=css"

const __exports__ = script;

export default __exports__